import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { WMTSSettings } from '../../explore-map.model';
import { ExploreMapService } from '../../explore-map.service';
import TileLayer from 'ol/layer/Tile';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-gazetteer-layer-panel',
  templateUrl: './gazetteer-layer-panel.component.html',
  styleUrls: ['./gazetteer-layer-panel.component.scss'],
})
export class GazetteerLayerPanelComponent implements OnInit {
  @Input() map: any;
  onDestroy$ = new Subject();

  gazetteerDatasets = [
    {
      displayName: 'All Gazetteer Layers',
      layerName: 'dataset-layer',
      visible: true,
      loaded: true,
      minZoom: 3,
      maxZoom: 12,
      zIndex: '-1',
    },
    {
      displayName: 'Administrative Unit',
      layerName: 'gazetteer_administrativeunit',
      visible: false,
      loaded: false,
      minZoom: 3,
      maxZoom: 12,
      zIndex: '5',
    },
    {
      displayName: 'Hydrography',
      layerName: 'gazetteer_hydrography',
      visible: false,
      loaded: false,
      minZoom: 10,
      maxZoom: 12,
      zIndex: '6',
    },
    {
      displayName: 'Populated Place',
      layerName: 'gazetteer_populatedplace',
      visible: false,
      loaded: false,
      minZoom: 11,
      maxZoom: 12,
      zIndex: '3',
    },
    {
      displayName: 'Protected Site',
      layerName: 'gazetteer_protectedsite',
      visible: false,
      loaded: false,
      minZoom: 8,
      maxZoom: 12,
      zIndex: '4',
    },
    {
      displayName: 'Transport Network',
      layerName: 'gazetteer_transportnetwork',
      visible: false,
      loaded: false,
      minZoom: 9,
      maxZoom: 12,
      zIndex: '2',
    },
  ];

  constructor(
    private exploreMapService: ExploreMapService,
    private activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.activatedRoute.paramMap.pipe(takeUntil(this.onDestroy$)).subscribe((params) => {
      if (params.get('mapServiceSlug') !== 'open-gazetteer') {
        this.setGazetteerSublayersInvisible();
        this.setVisibility('dataset-layer', true);
      }
    });
  }

  layerInZoomRange(layer: any): boolean {
    if (this.map) {
      let view = this.map.getView();
      let currentZoom = view.getZoom();
      return Math.round(currentZoom) > layer.maxZoom || Math.round(currentZoom) < layer.minZoom
        ? false
        : true;
    } else {
      return true;
    }
  }

  onCheckboxChange(gazetteerLayer): void {
    if (gazetteerLayer.layerName === 'dataset-layer' && !gazetteerLayer.visible) {
      /// When checking Open Gazetteer, uncheck all others
      this.setGazetteerSublayersInvisible();
    } else if (!gazetteerLayer.visible) {
      // When checking an individual layer, uncheck Open Gazetteer
      this.gazetteerDatasets.find((dataset) => dataset.layerName === 'dataset-layer').visible =
        false;
      this.setVisibility('dataset-layer', false);
    }
    gazetteerLayer.visible = !gazetteerLayer.visible;
    if (!gazetteerLayer.loaded) {
      this.addGazetteerLayer(gazetteerLayer);
    } else {
      this.setVisibility(gazetteerLayer.layerName, gazetteerLayer.visible);
    }
    let visibleLayer = this.gazetteerDatasets.map((layer) => {
      return layer.visible ? layer.layerName : null;
    });
    visibleLayer = visibleLayer.map((layer) =>
      layer === 'dataset-layer' ? 'open_gazetteer' : layer,
    );
    visibleLayer = visibleLayer.filter((x) => x !== null);
    this.exploreMapService.changeWMSLayer(visibleLayer);
  }

  setGazetteerSublayersInvisible(): void {
    this.gazetteerDatasets.map((dataset) => {
      if (dataset.layerName !== 'dataset-layer' && dataset.loaded && dataset.visible) {
        dataset.visible = false;
        this.setVisibility(dataset.layerName, false);
      }
    });
  }

  setVisibility(layerName: string, flag: boolean): void {
    this.map.getLayers().forEach((layer) => {
      if (layer && layer.get('name') === layerName) {
        layer.setVisible(flag);
      }
    });
  }

  addGazetteerLayer(layer: any): void {
    const newTileLayer = new TileLayer({
      source: null,
      properties: {
        name: layer.layerName,
      },
    });
    const wmtsSettings = new WMTSSettings();
    wmtsSettings.layerName = layer.layerName;
    wmtsSettings.url = `maps/wmts/${wmtsSettings.layerName}/{TileMatrixSet}/{TileMatrix}/{TileCol}/{TileRow}.png?token=${environment.elsToken}`;

    let wmtsSource = this.exploreMapService.getWMTSSource(wmtsSettings);

    layer.loaded = true;

    this.map.addLayer(newTileLayer);
    newTileLayer.setSource(wmtsSource);
    newTileLayer.setZIndex(layer.zIndex);
  }

  /**
   * @returns void
   */
  ngOnDestroy(): void {
    this.onDestroy$.next(null);
    this.onDestroy$.complete();
  }
}
